import Button from '@app-studio-web/ui/components/Button'
import InfoBox from '@app-studio-web/ui/components/InfoBox'
import Layout from '@app-studio-web/ui/components/Layout'
import { useTranslation } from 'react-i18next'
import { Form, useSubmit } from 'react-router-dom'

export default function OffToStartPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <Layout>
      <div
        className="flex h-full w-full flex-col text-center"
        style={{ justifyContent: 'space-between', alignItems: 'center' }}
      >
        {/* Removed emoji */}
        <h1 className="custom-heading my-5 text-3xl">
          {t('pages.onboarding.offToStart.heading')}
        </h1>
        <InfoBox>
          <span className="text-center text-base" style={{ fontSize: '20px' }}>
            {t('pages.onboarding.offToStart.description')}
          </span>
        </InfoBox>
        <Form
          className="shrink-0"
          method="post"
          onSubmit={handleSubmit}
          style={{ width: '100%' }}
        >
          <Button
            title={t('shared.continue')}
            type="submit"
            dataTestId="button-continue"
            className="w-full"
          />
        </Form>
      </div>
    </Layout>
  )
}
